export default "__VITE_ASSET__CMbjd0r5__"